import cep, { CEP } from 'cep-promise';
import { useQuery, UseQueryOptions } from 'react-query';

const useCEPQuery = (
  queryKey: string,
  options?: Omit<UseQueryOptions<CEP, Error, CEP, string>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<CEP, Error, CEP, string>(queryKey, {
    queryFn: async ({ queryKey }) => {
      const address: CEP = await cep(queryKey[0]);
      return address;
    },
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    ...options,
  });
};

export default useCEPQuery;
